import { render, staticRenderFns } from "./ListItemSkeleton.vue?vue&type=template&id=5225b51c&"
import script from "./ListItemSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ListItemSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SkeletonRect: require('/tmp/build_1fde6b87/src/components/skeleton/Rect.vue').default})
